import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/fi-rr-angle-small-right.svg'


const _withScopeId = n => (_pushScopeId("data-v-3ab7c4fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-mobile bg-custom-function overflow-auto" }
const _hoisted_2 = { class: "content-custom-functions content-points-details" }
const _hoisted_3 = { class: "mx-auto fw-medium" }
const _hoisted_4 = { class: "slider rounded-3" }
const _hoisted_5 = {
  key: 0,
  class: "slide-tracker d-flex"
}
const _hoisted_6 = ["onClick", "src"]
const _hoisted_7 = { class: "features-container" }
const _hoisted_8 = { class: "slide d-flex flex-wrap text-center justify-content-center position-static" }
const _hoisted_9 = { class: "features-container row-gap-3 py-3 px-2 d-flex justify-content-start flex-wrap" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "recent-msg-container bg-white rounded-3 mt-3 p-2" }
const _hoisted_13 = { class: "title-messages pb-3" }
const _hoisted_14 = {
  class: "content-messages overflow-auto",
  ref: "contentMessages"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "text-msg" }
const _hoisted_18 = {
  class: "catiguries-container bg-white my-3 rounded-3 py-2 text-center",
  ref: "catContainer"
}
const _hoisted_19 = {
  class: "catiguries-bar d-flex pb-2",
  ref: "catBar"
}
const _hoisted_20 = ["onClick", "id"]
const _hoisted_21 = { class: "catiguries-content mx-2 d-flex flex-wrap overflow-auto" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src", "onLoad"]
const _hoisted_24 = { class: "feature-title mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mask_layer = _resolveComponent("mask-layer")!
  const _component_Fade = _resolveComponent("Fade")!
  const _component_note_dialog = _resolveComponent("note-dialog")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["header d-flex text-black px-3 custom-fs-18 container-390 position-fixed", [$setup.getAgentType===1?'pth-android':$setup.getAgentType===2? 'pth-ios':'']])
        }, [
          _createElementVNode("img", {
            role: "button",
            src: _imports_0,
            alt: "back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeTab_()))
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.local.external_links_title), 1),
          _createElementVNode("button", {
            class: _normalizeClass(["notification-btn", [$setup.getAgentType===1?'top-btn-android':$setup.getAgentType===2? 'top-btn-ios':'']]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openComponent('showNote')))
          }, _toDisplayString($setup.local.external_links_dialog_title), 3)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["content-all-points px-3", [$setup.getAgentType===1?'ptc-android':$setup.getAgentType===2? 'ptc-ios':'']])
        }, [
          _createElementVNode("div", {
            class: "images-container px-2",
            style: {"cursor":"grab","touch-action":"pan-y"},
            onMousedown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.startDrag && $setup.startDrag(...args))),
            onMouseup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.endDrag && $setup.endDrag(...args))),
            onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.cancelDrag && $setup.cancelDrag(...args))),
            onMousemove: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.onDrag && $setup.onDrag(...args))),
            onTouchstart: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.startTouch && $setup.startTouch(...args))),
            onTouchmove: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.onTouchMove && $setup.onTouchMove(...args))),
            onTouchend: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.endTouch && $setup.endTouch(...args)))
          }, [
            _createElementVNode("div", _hoisted_4, [
              ($setup.images.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (img, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["point rounded-circle", [$setup.currentIndex === index ? 'active-point' : 'non-active-point']])
                      }, null, 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (img, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "slide rounded-8-px",
                  style: _normalizeStyle({
                            opacity: $setup.currentIndex === index ? 1 : 0,
                            zIndex: $setup.currentIndex === index ? 2 : 1
                        })
                }, [
                  _createElementVNode("img", {
                    onClick: ($event: any) => ((img.url || img.url2)?$setup.onImageClick():null),
                    src: img?.image_link??'',
                    draggable: "false",
                    onError: _cache[2] || (_cache[2] = ($event: any) => ($setup.onImageError($event))),
                    alt: "slide",
                    class: _normalizeClass([[$setup.state.loadingFeatures ? 'animation-icon' : ''], "rounded-8-px panel-image"])
                  }, null, 42, _hoisted_6)
                ], 4))
              }), 128))
            ])
          ], 32),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "slider features-slider",
              onTouchstart: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.onTouchStartFeatures && $setup.onTouchStartFeatures(...args))),
              onTouchend: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.onTouchEndFeatures && $setup.onTouchEndFeatures(...args)))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentSlideFeatures, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["feature", { 'fade-in': $setup.featuresAreVisible }]),
                      key: index + String($setup.currentFeaturesSlide * $setup.featuresPerSlide),
                      onClick: ($event: any) => (item.active?$setup.jumpUrl(item.url,item.id):null),
                      role: "button"
                    }, [
                      _createElementVNode("img", {
                        class: _normalizeClass(["feature-icon rounded-8-px", [$setup.state.loadingFeatures ? 'animation-icon' : '']]),
                        src: item?.image_link??'',
                        onError: _cache[10] || (_cache[10] = ($event: any) => ($setup.onIconFeatureError($event))),
                        alt: "feature"
                      }, null, 42, _hoisted_11),
                      _createElementVNode("div", {
                        class: _normalizeClass(["feature-title", [item.active ? '' : 'feature-title-off']])
                      }, _toDisplayString(item.active ? item.title : $setup.local.defaultFeatureName), 3)
                    ], 10, _hoisted_10))
                  }), 128))
                ])
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.local.recent_msg_title), 1),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.messages, (msg, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item-msg d-flex align-items-start column-gap-2 my-2",
                  key: index,
                  onClick: ($event: any) => (msg.url?$setup.jumpUrl(msg.url):null),
                  role: "button"
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass(["icon-msg rounded-circle", [$setup.state.loadingFeatures ? 'rounded-circle animation-icon' : '']]),
                    src: msg?.image??'',
                    alt: "msg",
                    onError: _cache[13] || (_cache[13] = ($event: any) => ($setup.onIconMsgFaild($event)))
                  }, null, 42, _hoisted_16),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(msg.title), 1)
                ], 8, _hoisted_15))
              }), 128))
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.catiguries, (_, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["tab-catigury", [$setup.currentCatigury === key ? 'selected-tab-cat' : '']]),
                  key: key,
                  onClick: ($event: any) => ($setup.selectCatigury(key)),
                  id: `cat-${$setup.keyToIndex[key]}`,
                  role: "button"
                }, _toDisplayString($setup.currentCatigury.includes('cat_local') ? $setup.tabsCatiguries[key] : key), 11, _hoisted_20))
              }), 128))
            ], 512),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.catiguries[$setup.currentCatigury], (feature, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["catigury mt-3", { 'fade-in': $setup.featuresAreVisible1 }]),
                  onClick: ($event: any) => (feature.url?$setup.jumpUrl(feature.url,feature.id):null),
                  role: "button",
                  key: $setup.currentCatigury + index
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass(["feature-icon rounded-8-px", [($setup.state.loadingFeatures || !feature.load) ? 'animation-icon' : '']]),
                    src: feature.load?feature?.image_link ?? '' : $setup.featureLoadingIcon_,
                    onError: _cache[14] || (_cache[14] = ($event: any) => ($setup.onIconFeatureError($event))),
                    onLoad: ($event: any) => ($setup.onIconFeatureLoading(feature.id,$setup.currentCatigury)),
                    alt: "feature"
                  }, null, 42, _hoisted_23),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(feature?.title??$setup.local.category), 1)
                ], 10, _hoisted_22))
              }), 128))
            ])
          ], 512)
        ], 2)
      ]),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_mask_layer, null, null, 512), [
            [_vShow, $setup.state.showLoading || $setup.state.showNote]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_note_dialog, {
            onKnew: _cache[15] || (_cache[15] = ($event: any) => ($setup.closeComponent('showNote')))
          }, null, 512), [
            [_vShow, $setup.state.showNote]
          ])
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode(_component_Spinner, null, null, 512), [
      [_vShow, $setup.state.showLoading]
    ])
  ], 64))
}